(ns renolit-roofing-service.layout.form.form-item.date-picker
  (:require [cljc.java-time.instant :as jt.instant]
            [cljc.java-time.local-date :as jt.local-date]
            [cljc.java-time.local-date-time :as jt.local-date-time]
            [cljc.java-time.local-time :as jt.local-time]
            [cljc.java-time.zone-id :as jt.zone-id]
            [cljc.java-time.zoned-date-time :as jt.zoned-date-time]
            [goog.object :as g]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.advanced-tooltip :as layout.advanced-tooltip]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.util.react-date-range :as util.react-date-range]
            ["@floating-ui/react" :as floating-ui-react]
            ["react" :as react]
            ["react-date-range" :as react-date-range]))

(defn- set-dropdown-size
  [state]
  (let [{:keys [rects elements]} (js->clj state :keywordize-keys true)
        reference-width (get-in rects [:reference :width])
        floating-style (g/getValueByKeys (:floating elements) "style")
        style-changes {:width (str reference-width "px")}]
    (js/Object.assign floating-style (clj->js style-changes))))

(defn- date-picker-display
  [{:keys [context path disabled?]}]
  (let [form-errors (rf/subscribe [::form.error/errors context path])]
    (fn [{:keys [state path label-transl-kw mandatory? date-type]}]
      [:div.form-item.date-picker-display
       {:class [(when (seq @form-errors) "form-item--error")
                (when disabled? "date-picker-display--disabled")]}
       (when label-transl-kw
         [:label.form-item__label
          (t [label-transl-kw])
          (when mandatory?
            [:span.form-item__mandatory "*"])])
       [:button.date-picker-display__form-input
        (if-let [selected (get-in @state path)]
          [:span (util.react-date-range/format-date date-type :to selected)]
          [:span.date-picker-display__placeholder
           (t [:common/select])])
        [layout.icon/icon
         {:class "date-picker-display__icon"
          :key "calendar_today"}]]])))

(defn- value->date-time-status
  [instant]
  (let [time-zone (jt.zone-id/system-default)]
    (if instant
      {:date (-> (jt.instant/at-zone instant time-zone)
                 (jt.zoned-date-time/to-local-date))
       :time-zone time-zone
       :time (-> (jt.instant/at-zone instant time-zone)
                 (jt.zoned-date-time/to-local-time))}
      {:date nil
       :time-zone time-zone
       :time (jt.local-time/of 23 59)})))

(defn- date-time-status->value
  [{:keys [date time-zone time]}]
  (when (and date time-zone time)
    (-> (jt.local-date/at-time date time)
        (jt.local-date-time/at-zone time-zone)
        (jt.zoned-date-time/to-instant))))

(defn- date-time-picker-selector
  [{:keys [state path max-date min-date]}]
  (let [initial-value (get-in @state path)
        local-state (r/atom (value->date-time-status initial-value))
        time-zone-choices (map (fn [zone-id]
                                 {:id zone-id
                                  :name (str zone-id)})
                               (jt.zone-id/get-available-zone-ids))]
    (fn [{:keys [state path on-change]} set-open]
      [:div.date-picker-selector
       [:> react-date-range/Calendar
        (cond->
         {:date (util.react-date-range/date->lib-date
                 :local-date :from (:date @local-state))
          :on-change (fn [change]
                       (let [new-date (util.react-date-range/lib-date->date :local-date :from change)
                             new-status (swap! local-state assoc :date new-date)
                             new-value (date-time-status->value new-status)]
                         (when (and (not (:prevent-default? on-change)) state)
                           (swap! state assoc-in path new-value))
                         (util/execute-callback on-change new-value)
                         (set-open false)))}
          max-date
          (assoc :max-date (util.react-date-range/limit-date->lib-limit-date max-date))

          min-date
          (assoc :min-date (util.react-date-range/limit-date->lib-limit-date min-date)))]
       [:div.date-picker-selector__footer
        [form.form-item/form-item-component
         {:state local-state
          :path [:time]
          :type :time-picker
          :mandatory? true
          :on-change {:fn (fn [new-time]
                            (when new-time
                              (let [new-status (swap! local-state assoc :time new-time)]
                                (when-let [new-value (date-time-status->value new-status)]
                                  (when (and (not (:prevent-default? on-change)) state)
                                    (swap! state assoc-in path new-value))
                                  (util/execute-callback on-change new-value)))))}}]
        [form.form-item/form-item-component
         {:state local-state
          :path [:time-zone]
          :type :advanced-select-with-fixed-choices
          :search? true
          :mandatory? true
          :choices time-zone-choices
          :on-change {:fn (fn [new-time-zone]
                            (let [new-time-zone (when new-time-zone (jt.zone-id/of new-time-zone))
                                  new-status (swap! local-state assoc :time-zone new-time-zone)]
                              (when-let [new-value (date-time-status->value new-status)]
                                (when (and (not (:prevent-default? on-change)) state)
                                  (swap! state assoc-in path new-value))
                                (util/execute-callback on-change new-value))))}}]]])))

(defn- date-picker-selector
  [{:keys [state path on-change date-type min-date max-date]} set-open]
  [:div.date-picker-selector
   [:> react-date-range/Calendar
    (cond->
     {:date (util.react-date-range/date->lib-date
             date-type :from (get-in @state path))
      :on-change
      (fn [change]
        (let [new-value (util.react-date-range/lib-date->date date-type :from change)]
          (when (and (not (:prevent-default? on-change)) state)
            (swap! state assoc-in path new-value))
          (util/execute-callback on-change new-value)
          (set-open false)))}
      max-date
      (assoc :max-date (util.react-date-range/limit-date->lib-limit-date max-date))

      min-date
      (assoc :min-date (util.react-date-range/limit-date->lib-limit-date min-date)))]])

(defn- date-picker
  [opts]
  (let [[is-open set-open] (react/useState false)
        use-floating (layout.advanced-tooltip/use-floating
                      {:whileElementsMounted floating-ui-react/autoUpdate
                       :placement "bottom"
                       :open is-open
                       :onOpenChange set-open
                       :middleware [(floating-ui-react/offset 5)
                                    (floating-ui-react/flip)
                                    (floating-ui-react/size
                                     (clj->js {:apply set-dropdown-size}))]})
        use-interactions (layout.advanced-tooltip/use-interactions
                          (:context use-floating)
                          {:dismiss {:ancestorScroll true}
                           :click {:toggle true
                                   :enabled (not (:disabled? opts))}})]
    [:div.date-picker
     [:div.date-picker__reference
      (assoc (:reference-props use-interactions)
             :ref #(.setReference (:refs use-floating) %))
      [date-picker-display opts]]
     (when is-open
       [:> floating-ui-react/FloatingPortal
        {:id "app-container"}
        [:> floating-ui-react/FloatingFocusManager
         {:context (:context use-floating)}
         [:div.date-picker__floating
          (assoc (:floating-props use-interactions)
                 :ref #(.setFloating (:refs use-floating) %)
                 :style (:style use-floating))
          (if (= :instant (:date-type opts))
            [date-time-picker-selector opts set-open]
            [date-picker-selector opts set-open])]]])]))

(defn- main
  [opts]
  [:f> date-picker opts])

(defmethod form.form-item/form-item-component :date-picker
  [opts]
  [main opts])
